import styled from 'styled-components';
import { typographyTokenMapping, getTypographyStyles } from '@oneaudi/unified-web-common';
import { getMargins } from '@oneaudi/unified-web-common';
import { FootnoteStyle } from '../text/index.styles.js';
export const StyledHeadline = styled.div `
  margin: ${(props) => getMargins(props.margin) || 0};
  color: ${(props) => props.theme.global.color.typography.headline.default};

  ${(props) => {
    const { type, order, weight } = props.variant;
    const getTokenType = () => {
        if (type === 'headline') {
            return typographyTokenMapping.sys.typography[type]['order'][order][weight];
        }
        return typographyTokenMapping.sys.typography[type]['order'][order][weight];
    };
    return getTypographyStyles(getTokenType());
}};

  ${FootnoteStyle}
`;
//# sourceMappingURL=index.styles.js.map